import React, { useState, useEffect, useContext, useRef } from "react"

import clsx from 'clsx';
import { useTheme, Box, Tooltip, Badge, Alert } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { CircularProgress } from "@mui/material";

import Main from "../../components/Main"

import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ReportIcon from '@mui/icons-material/Assessment';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import TemplateIcon from '@mui/icons-material/NotificationAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import ManageCallsIcon from '@mui/icons-material/ManageAccounts';
import ClientsIcon from '@mui/icons-material/Groups';
import ConstructionIcon from '@mui/icons-material/Construction';
import CellTowerIcon from '@mui/icons-material/CellTower';
import CampaignIcon from '@mui/icons-material/Campaign';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import GroupsIcon from '@mui/icons-material/Groups';
import ContactSupportIcon from "@mui/icons-material/ContactSupport"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"
import FeedIcon from "@mui/icons-material/Feed"

import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';

import { useLocation, useHistory } from "react-router-dom"

import PropTypes from "prop-types";
import { getSession, clearToken, clearSession, getToken, saveToken, clearAssistantTabId } from "../../auth";

import AccountMenu from '../Menu/AccountMenu';
import LogoImage from '../../assets/images/kwik_color.png';
import LogoFavIcon from '../../assets/images/kwik_favicon.png';
import CortexIcon from "../Cortex/icon"

import ConfirmationDialog from '../Dialogs/Confirmation';

import userPermissions from '../User/Permissions';

import useNotification from "../Notification";
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { setFaviconBadge } from '../../utils/favicon';
import { isPageVisible } from '../../utils/isVisible';
import 'animate.css/animate.min.css';

import { registerModuleAccess } from '../../utils/useModuleAccess'
import api from '../../api'

import "./styles.css";

import { QueueSocket } from '../../routes';
import ChargeStatus from './charge_status';
import CryptoJS from 'crypto-js';

export const hasKwik = (platforms) => {
    return (
        platforms.chat_web ||
        platforms.email ||
        platforms.instagram ||
        platforms.whatsapp ||
        platforms.messenger ||
        platforms.telegram 
    );
};


const convert_link = (syllab) => {
    if (syllab.includes('http') || syllab.includes('https://') ){
        if (syllab.includes('|||')){
            const [url, name] = syllab.split('|||')
            return <><a target="#" href={url}>{name.replace('_',' ')}</a> </>
        }
        return <><a target="#" href={syllab}>https://kwik.app.br/{CryptoJS.MD5(syllab).toString().substring(0,4)}</a> </>
    }
    return <span>{syllab} </span>
}

// const MiniDrawer = ({ child, socket }) => {
const MiniDrawer = ({ child }) => {


    const { chatState, notifications, setNotifications, connections } = useContext(QueueSocket)

    const theme = useTheme();

    const [open, setOpen] = useState(false);
    const [confirmRequeue, setConfirmRequeue] = useState(false);
    const [isLogoutButtonLoading, setIsLogoutButtonLoading] = useState(false);
    const [isRequeueLoading, setIsRequeueLoading] = useState(false);
    const [route, setRoute] = useState(0);
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
    const [announcement, setAnnouncement] = useState()

    const [ hasNewMessage, setHasNewMessage ] = useState(false)

    const [hidePortalBadge, setHidePortalBadge] = useState(true)

    const history = useHistory();
    const user = getSession();
    const groups = userPermissions();
    const platforms = user.profile.enterprise.platforms
    const settings = user.profile.enterprise.settings

    const selectedPage = (pagename) => {
        if (window.location.pathname === pagename)
            return { sx: {color:'#21446C'}}
    }

    const pages = [
      {
        name: "dashboard",
        description: "Dashboard",
        tooltip: "Dashboard",
        onClick: () => navigate("/dashboard"),
        icon: <DashboardIcon {...selectedPage("/dashboard")} />,
        // isVisible: groups.isSupervisor && hasKwik(platforms),
        isVisible: groups.isSupervisor, // TODO: validate whether enterprise has any platform
      },
      {
        name: "chat",
        description: "Atendimento",
        tooltip: "Atendimento",
        onClick: () => {
          navigate("/chat");
          setNotifications(false);
        },
        icon: (
          <Badge
            color="success"
            variant="dot"
            invisible={!notifications || !settings.websockets}
          >
            <QuestionAnswerIcon {...selectedPage("/chat")} />
          </Badge>
        ),
        // isVisible: groups.isOperator && hasKwik(platforms),
        isVisible: groups.isOperator, // TODO: validate whether enterprise has any platform
      },
      {
        name: "scout",
        description: "Scout",
        tooltip: 'Kwik Scout',
        onClick: () => navigate("/scout"),
        icon: <ImportantDevicesIcon {...selectedPage("/scout")} />,
        // isVisible: groups.isSupervisor && getSession().profile.scout,
        isVisible: groups.isSupervisor, // TODO: validate whether enterprise has scout and user has scout
      },
      {
        name: "reports",
        description: "Relatórios",
        tooltip: "Relatórios",
        onClick: () => navigate("/report"),
        icon: <ReportIcon {...selectedPage("/report")} />,
        // isVisible: groups.isSupervisor && hasKwik(platforms),
        isVisible: groups.isSupervisor, // TODO: validate whether enterprise has any platform
      },
      {
        name: "channels",
        description: "Canais",
        tooltip: "Canais de atendimento",
        onClick: () => navigate("/channels"),
        icon: <CellTowerIcon {...selectedPage("/channels")} />,
        // isVisible:
        //   groups.isAdmin &&
        //   Object.keys(platforms).some(
        //     (k) => k != "chat_web" && platforms[k] === true
        //   ),
        isVisible: groups.isAdmin, // TODO: validate platforms internally
      },
      {
        name: "cortex",
        description: "Cortex",
        tooltip: "Cortex",
        onClick: () => navigate("/cortex?assistant=knowledgeBases"),
        icon: <CortexIcon {...selectedPage("/cortex")} />,
        isVisible: groups.isAdmin,
      },
      {
        name: "builder",
        description: "Fluxos",
        tooltip: "Fluxos",
        onClick: () => navigate("/builder"),
        icon: <SupportAgentIcon {...selectedPage("/builder")} />,
        // isVisible: groups.isAdmin && settings.bot,
        isVisible: groups.isAdmin, // TODO: settings.bot deprecated
      },
      {
        name: "automation",
        description: "Automação",
        tooltip: "Automações",
        onClick: () => navigate("/automation"),
        icon: <SmartToyIcon {...selectedPage("/automation")} />,
        // isVisible: groups.isAdmin && user.profile.enterprise.automation,
        isVisible: groups.isAdmin, // TODO: validate automation flag internally
      },
      {
        name: "settings",
        description: "Configurações",
        tooltip: "Configurações",
        onClick: () => navigate("/settings"),
        icon: <SettingsIcon {...selectedPage("/settings")} />,
        isVisible: groups.isSupervisor, // TODO: validate other accesses internally
      },
      {
        name: "portal",
        description: "Novidades",
        tooltip: "Novidades e Soluções",
        onClick: () => {
            localStorage.setItem(
                "portal-last-access",
                new Date().toISOString()
            )
            setHidePortalBadge(true)
            navigate("/portal")
        },
        icon: (
            <Badge
                color="success"
                variant="dot"
                invisible={hidePortalBadge}
            >
                <FeedIcon {...selectedPage("/portal")} />
          </Badge>
        ),
        isVisible: groups.isOperator,
      },
    ];

    const mobilePages = [
        {
            name: "chat",
            description: "Chat",
            onClick: () => navigate('/chat'),
            icon: <QuestionAnswerIcon />,
            isVisible: groups.isOperator
        },
        {
            name: "crm",
            description: "Clientes",
            onClick: () => navigate('/crm'),
            icon: <ClientsIcon />,
            isVisible: groups.isOperator
        },
        {
            name: "logout",
            description: "Logout",
            onClick: () => setShowLogoutConfirmation(true),
            icon: <LogoutIcon />,
            isVisible: groups.isOperator
        },
    ];
    const navigate = (url) => {
        const pathname = url.split("?")[0];
        const modules = { "/scout": "scout", "/cortex": "cortex", "/builder": "builder", "/automation": "automation" };
        if (history.location.pathname === pathname)
            registerModuleAccess(modules[pathname]);
        history.push(url);
    };

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const drawerWidth = 200;

    //I did not found the exposed path to kwikchat, so i routed the command to server and handled there.
    //We don't even need to wait.
    const addNewChat = async (queueName, channel) => {
        const url = `api/enterprises/${user.profile.enterprise.id}/calls/chat/transfer/${queueName}/${channel}/`
        api.get(url)
    }

    const requeueAgentChats = () => {
        setIsRequeueLoading(true);
        api.post(`/api/IV/agents/${user.profile.agent_id}/requeue_chats/`)
            .then((res) => {
                if (res.status == 200) {
                    //remove ongoing chats from supervisors
                    if (res.data) {
                        res.data.map(chat => {
                            const queue_name = chat.queues_name
                            const channel = chat.channel ? chat.channel : chat.hash
                            const connection = connections?.find(con => con.queue == queue_name)
                            if (queue_name && connection && channel) {
                                connection.send(JSON.stringify({ message: "DROP_CHAT", channel: { channel: chat.channel, user: user.profile.agent.name } }))
                                addNewChat(queue_name, channel)
                            }

                        })

                    }
                    handleLogout();
                    return;
                }
                setIsRequeueLoading(false);
                throw res;
            })
            .catch(async (err) => {
                console.error(err);
                useNotification(
                    'Ops!',
                    'Ocorreu um erro no sistema',
                    'danger'
                );
            });
    }

    const checkOnline = async () => {
        const user = getSession();
        const res = await api.get(`/api/enterprises/${user.profile.enterprise.id}/users/${user.id}/useronline/`)
        if (res.status == 200) {
            if (res.data == 'LOGOFF') {
                clearSession();
                clearToken();
                document.location.href = '/?typeAlert=error&showAlert=Usuário deslogado externamente.';
            }
            return
        }
    }

    const getLatestPortalUpdate = async () => {
        const enterpriseId = getSession().profile?.enterprise?.id
        if (! enterpriseId)
            return

        const res = await api.get(`/api/portal/latest_update/`)
        if (res.status == 200) {
            const latestUpdate = new Date(`${res.data.latest_update}Z`)
            const lastPortalAccess = localStorage.getItem("portal-last-access")
            const lastAccessDate = lastPortalAccess
                ? new Date(lastPortalAccess)
                : null
            if (!lastPortalAccess || latestUpdate > lastAccessDate) {
                setHidePortalBadge(false)
            }
        }
    }

    useEffect(() => {
        checkOnline()
        getLatestPortalUpdate()
    }, [route])

    const location = useLocation()
    const pollingRef = useRef(null)
    const isPolling = useRef(false)
    const unreadQueue = useRef(null)
    const unreadQueueMessages = useRef(null)
    const unreadChats = useRef(null)
    const unreadCount = useRef(null)

    const poll = async () => {
        try {
            const enterpriseId = getSession().profile?.enterprise?.id
            const response = await api.get(`api/enterprises/${enterpriseId}/calls/chat/count/?filtered=False&allTabs=True`)
            if (response.status === 200) {
                const countQueue = response.data["queued"] || 0
                const countQueueMessages = response.data["unreadqueuedmessages"] || 0
                const countChats = response.data["onchat"]
                const countMessages = response.data["unreadonchatmessages"] || 0
                
                if (unreadQueue.current === null || unreadQueueMessages.current === null || unreadChats.current === null || unreadCount.current === null) {
                    unreadQueue.current = countQueue
                    unreadQueueMessages.current = countQueueMessages
                    unreadChats.current = countChats
                    unreadCount.current = countMessages
                    return
                }
                
                const defaultNotificationSettings = {
                    new_queue: { notification: false, sound: false, visibility: 'always' },
                    new_queue_message: { notification: false, sound: false, visibility: 'always' },
                    new_chat: { notification: true, sound: true, visibility: 'always' },
                    new_message: { notification: true, sound: true, visibility: 'always' },
                }

                const getNotificationConfig = (type) => {
                    const settings = getSession()?.profile?.enterprise?.settings || {}
                    const notificationSettings = settings.notification_settings || defaultNotificationSettings
                    return notificationSettings[type] || defaultNotificationSettings[type]
                }

                const notifyUser = (title, body, type = 'new_message') => {
                    const notificationConfig = getNotificationConfig(type)
                    const notificationEnabled = notificationConfig.notification !== false
                    const soundEnabled = notificationConfig.sound !== false
                    const visibility = notificationConfig.visibility || 'always'
                    const urlParams = new URLSearchParams(window.location.search)
                    
                    // Not running if on chat service tab
                    if (window.location.pathname === "/chat" && urlParams.get("selectedTab") === "service")
                        return

                    const visible = isPageVisible()

                    if (visibility === 'other_tabs' && !(visible))
                        return
                    if (visibility === 'outside_kwik' && visible)
                        return
                    if (visibility !== 'always' && visibility !== 'other_tabs' && visibility !== 'outside_kwik' && visible)
                        return

                    if (!notificationEnabled && !soundEnabled)
                        return

                    setFaviconBadge('message', true)
                    setHasNewMessage(true)

                    if (soundEnabled) {
                        const audio = new Audio(`${window.location.origin}/new_message.mp3`)
                        audio.play().catch(() => {})
                    }

                    if (!notificationEnabled)
                        return

                    if (Notification.permission === "default")
                        Notification.requestPermission()
                    if (Notification.permission === "granted") {
                        const notification = new Notification(title, {
                            body,
                            lang: "pt-BR",
                            icon: `${window.location.origin}/kwik_favicon.png`,
                            silent: true,
                        })

                        notification.addEventListener("click", () => {
                            window.focus()
                            window.location.href = `${window.location.origin}/chat?selectedTab=service`
                        })
                    }
                }

                if (countQueue > unreadQueue.current) {
                    unreadQueue.current = countQueue
                    unreadQueueMessages.current = countQueueMessages
                    notifyUser("Novo chat", "Novo atendimento em fila.", "new_queue")
                    return
                }

                if (countQueueMessages > unreadQueueMessages.current) {
                    unreadQueueMessages.current = countQueueMessages
                    notifyUser("Novo mensagem", "Novo mensagem em um atendimento em fila.", "new_queue_message")
                    return
                }

                if (countChats > unreadChats.current) {
                    unreadChats.current = countChats
                    unreadCount.current = countMessages
                    notifyUser("Novo chat", "Você recebeu um novo atendimento.", "new_chat")
                    return
                }

                if (countMessages > unreadCount.current) {
                    unreadCount.current = countMessages
                    notifyUser("Nova mensagem", "Você recebeu uma nova mensagem em um de seus atendimentos.", "new_message")
                    return
                }
            }
        } catch (err) {
            console.error(err)
        } finally {
            if (isPolling.current)
                pollingRef.current = setTimeout(poll, 10000)
        }
    }

    // all tabs notification deprecated !

    // useEffect(() => {
    //     const params = new URLSearchParams(location.search)
    //     const selectedTab = params.get("selectedTab")
    //     if (selectedTab === "service")
    //         setHasNewMessage(false)
    //     if (selectedTab !== "service" && !isPolling.current) {
    //         isPolling.current = true
    //         poll()
    //     }
    //     return () => {
    //         if (pollingRef.current) {
    //             clearTimeout(pollingRef.current)
    //             pollingRef.current = null
    //             unreadCount.current = null
    //             isPolling.current = false
    //         }
    //     }
    // }, [location])

    const handleLogout = () => {
        setIsLogoutButtonLoading(true);
        const user = getSession();
        if (user.profile.agent_id) {
            // if there's an external agent related to this user we should also log this agent out
            if (user.profile.instantvoice_agent_code)
                api.post(`/api/IV/agents/${user.profile.id}/instantvoice_agent_logoff/`)
            const token = getToken();
            const vanityUrl = user.profile.enterprise?.settings?.vanity_url;
            const entraEnabled = user.profile.enterprise?.entra_config?.enabled;
            api.post(`/api/IV/agents/${user.profile.agent_id}/logout/`)
                .then((res) => {
                    if (res.status == 200) {
                        clearSession();
                        clearToken();
                        clearAssistantTabId();
                        // enterprises with a custom, enabled EntraID login page should land back on it, not the default form
                        document.location.href = (vanityUrl && entraEnabled) ? `/login/${vanityUrl}` : '/';
                        return;
                    }
                    throw res;
                })
                .catch((err) => {
                    if (err.data) {
                        if (err.data == 'Você não pode deslogar com atendimentos em andamento')
                            setConfirmRequeue(true);
                        else
                            useNotification('Atenção!', err.data, 'warning');
                    }
                    setIsLogoutButtonLoading(false);
                });
        }
    };

    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            backgroundColor: '#5399DB'
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 15,
            marginLeft: -20
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(7)
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: 10
        },
        content: {
            width: '100%',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        },
    }));

    const classes = useStyles();
    const appClasses = clsx(classes.appBar, { [classes.appBarShift]: open, }) + ' app-bar';
    const drawerClasses = clsx(classes.drawer, { [classes.drawerOpen]: open, [classes.drawerClose]: !open, }) + ' left-drawer';

    useEffect(() => {
        switch (window.location.pathname) {
            case '/crm':
                setRoute(1);
                break;
            default:
                setRoute(0);
                break;
        }
    }, []);

    useEffect(() => {
        const fetchAnnouncements = () => {
            api.get('/api/announcements/').then((res) => { 
                if (res.status === 200) 
                    setAnnouncement(res.data) 
            }).catch((err) => {})
        };
        fetchAnnouncements()
        const intervalId = setInterval(fetchAnnouncements, 600000)
        return () => clearInterval(intervalId)
    }, [])

    const hasBlockedChannels = () => {
        let blocked = false
        user.profile.enterprise.channels.forEach((channel) => {
            if ('info_360dialog' in channel && channel.info_360dialog !== undefined && channel.info_360dialog !== null && channel.info_360dialog?.account_mode !== 'live')
                blocked = true
        })
        return blocked
    }

    return (
        <div className={classes.root}>
            {/* <ReactNotifications /> */}
            <AppBar
                position="relative"
                className={appClasses}
            >
                <Toolbar className="toolbar-body">
                    <Box sx={{ display: "flex" }} flexGrow={1}>
                        {(groups.isSupervisor || groups.isAdministrator) &&
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                className={clsx(classes.menuButton, {
                                    [classes.hide]: open,
                                })}
                                size="large">
                                <MenuIcon />
                            </IconButton>
                        }
                        <img src={LogoImage}
                            alt="logo"
                            className="logo"
                            id="logo"
                        />
                        <ChargeStatus status={user.profile.enterprise?.charge_status} />
                        {announcement &&
                            <Alert variant="filled" severity="warning" className="trial-info-alert">
                                {announcement.message.split(' ').map(syllab => convert_link(syllab))}
                            </Alert>   
                        }
                        {user.profile.enterprise.is_trial &&
                            <Alert variant="filled" severity="warning" className="trial-info-alert">
                                Período de degustação encerra em {new Date(user.profile.enterprise.trial_end_at).toLocaleString('pt-BR')}
                            </Alert>
                        }
                        {hasBlockedChannels() &&
                            <Alert variant="filled" severity="error" className="trial-info-alert">
                                Você possui um (ou mais) números WhatsApp inativos ou bloqueados.
                                Verifique em "Canais de Atendimento" {'>'} "WhatsApp".
                            </Alert>
                        }
                    </Box>
                    <AccountMenu
                        user={user}
                        menuItems={[{
                            icon: isLogoutButtonLoading
                                ? <CircularProgress color="inherit" size={16} />
                                : <LogoutIcon fontSize="small" />,
                            title: 'Sair',
                            onClick: () => handleLogout()
                        }]}
                        isLogoutButtonLoading={isLogoutButtonLoading}
                    />
                </Toolbar>
            </AppBar>
            <Box className="body-kwik">
                <ConfirmationDialog open={confirmRequeue}
                    title="Não é permitido deslogar com chats em atendimento"
                    description={(
                        <Box>
                            Deseja que os chats em atendimento sejam
                            transferidos de volta para suas respectivas
                            filas de origem?
                        </Box>
                    )}
                    handleClose={() => setConfirmRequeue(false)}
                    handleSubmit={() => requeueAgentChats()}
                    submitButtonLoading={isRequeueLoading}
                />

                <ConfirmationDialog open={showLogoutConfirmation}
                    title="Logout"
                    description={(
                        <Box>
                            Deseja realizar logout do sistema?
                        </Box>
                    )}
                    handleClose={() => setShowLogoutConfirmation(false)}
                    handleSubmit={() => handleLogout()}
                    submitButtonLoading={isLogoutButtonLoading}
                />

                {(groups.isSupervisor || groups.isAdministrator) &&
                    <Drawer
                        variant="permanent"
                        className={drawerClasses}
                        classes={{
                            paper: clsx({
                                [classes.drawerOpen]: open,
                                [classes.drawerClose]: !open,
                            }),
                        }}
                    >
                        <img src={LogoFavIcon}
                            alt="logo"
                            className="logoFavIcon"
                            id="logoFavIcon"
                        />
                        <div className={classes.toolbar}>
                            <IconButton onClick={handleDrawerClose} size="large">
                                {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                            </IconButton>
                        </div>
                        <List>
                            {pages.map((item, index) => (
                                item.isVisible
                                    ? (
                                        <Tooltip title={item.tooltip} placement="right" disableInteractive key={index}>
                                            <span>
                                            <ListItem disabled={item.isDisabled} button key={index} onClick={item.onClick}>
                                                <ListItemIcon sx={{ position: "relative" }}>
                                                    {item.icon}
                                                    {item.description === "Atendimento" && hasNewMessage &&
                                                        <Box
                                                            sx={{
                                                                position: "absolute",
                                                                top: "-8px",
                                                                right: "25px",
                                                                width: "12px",
                                                                height: "12px",
                                                                borderRadius: "50%",
                                                                backgroundColor: "#5f8963",
                                                                border: "2px solid white",
                                                            }}
                                                        />
                                                    }
                                                </ListItemIcon>
                                                <ListItemText style={{ marginLeft: -15 }}
                                                    primary={item.description}
                                                />
                                            </ListItem>
                                            </span>
                                        </Tooltip>
                                    ) 
                                    : null
                            ))}
                        </List>
                    </Drawer>
                }

                <main style={{ flex: 1 }} className={classes.content}>
                    {child?.type === Main
                        ? React.cloneElement(child, {hasNewMessage})
                        : child
                    }
                </main>
            </Box>
            <Box className="mobile-navigation">
                <BottomNavigation
                    showLabels
                    value={route}
                    onChange={(event, newValue) => {
                        mobilePages[newValue].onClick();
                        setRoute(newValue);
                    }}
                >
                    {mobilePages.map((item, index) => (
                        item.isVisible && (
                            <BottomNavigationAction
                                label={item.description}
                                icon={item.icon}
                                key={index}
                            />
                        )
                    ))}
                </BottomNavigation>
            </Box>
        </div>
    );
}

MiniDrawer.propTypes = {
    child: PropTypes.any
}

export default MiniDrawer;
